// extracted by mini-css-extract-plugin
export default {"root":"HgO8uZECLiPAfp06OcE6","btn":"OL_OcWdjYmc0qmY6rNob","approve":"sOPxJtANSELV91TkBWY4 OL_OcWdjYmc0qmY6rNob","reject":"rreLANCrm1sBoHfXCw2N OL_OcWdjYmc0qmY6rNob"};